import { Textarea, Label } from '@creanizer/ui'
import type { CharacterEmotionalExpression } from '@creanizer/types'

interface EmotionalExpressionEditorProps {
  emotionalExpression: CharacterEmotionalExpression
  onChange: (emotionalExpression: CharacterEmotionalExpression) => void
}

export function EmotionalExpressionEditor({
  emotionalExpression,
  onChange
}: EmotionalExpressionEditorProps) {
  const handleChange = (field: keyof CharacterEmotionalExpression, value: string) => {
    onChange({
      ...emotionalExpression,
      [field]: value
    })
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="joy">喜びの表現</Label>
          <Textarea
            id="joy"
            value={emotionalExpression.joy || ''}
            onChange={(e) => handleChange('joy', e.target.value)}
            placeholder="例: 目を輝かせ、声が弾む"
            rows={2}
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="anger">怒りの表現</Label>
          <Textarea
            id="anger"
            value={emotionalExpression.anger || ''}
            onChange={(e) => handleChange('anger', e.target.value)}
            placeholder="例: 静かに目を細める"
            rows={2}
            className="mt-1"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="sadness">哀しみの表現</Label>
          <Textarea
            id="sadness"
            value={emotionalExpression.sadness || ''}
            onChange={(e) => handleChange('sadness', e.target.value)}
            placeholder="例: 黙り込み、視線を落とす"
            rows={2}
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="enjoyment">楽しみの表現</Label>
          <Textarea
            id="enjoyment"
            value={emotionalExpression.enjoyment || ''}
            onChange={(e) => handleChange('enjoyment', e.target.value)}
            placeholder="例: 口元が緩み、饒舌になる"
            rows={2}
            className="mt-1"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="emotionalControl">感情の抑制度合い</Label>
        <Textarea
          id="emotionalControl"
          value={emotionalExpression.emotionalControl || ''}
          onChange={(e) => handleChange('emotionalControl', e.target.value)}
          placeholder="例: 普段は穏やかだが、大切な人が傷つくと感情的になる"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="stressRelief">ストレス発散方法</Label>
        <Textarea
          id="stressRelief"
          value={emotionalExpression.stressRelief || ''}
          onChange={(e) => handleChange('stressRelief', e.target.value)}
          placeholder="例: 一人で散歩する、音楽を聴く"
          rows={2}
          className="mt-1"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="cryingStyle">泣くときの特徴</Label>
          <Textarea
            id="cryingStyle"
            value={emotionalExpression.cryingStyle || ''}
            onChange={(e) => handleChange('cryingStyle', e.target.value)}
            placeholder="例: 人前では泣かない、静かに涙を流す"
            rows={2}
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="laughingStyle">笑い方の特徴</Label>
          <Textarea
            id="laughingStyle"
            value={emotionalExpression.laughingStyle || ''}
            onChange={(e) => handleChange('laughingStyle', e.target.value)}
            placeholder="例: 控えめに微笑む、大声で笑う"
            rows={2}
            className="mt-1"
          />
        </div>
      </div>
    </div>
  )
}
